export const isPolicyResultConfirmed = ({ code }) => `${code}` === '10'
export const isPolicyResultPending = ({ code }) => `${code}` === '20'
export const isPolicyResultSuccess = (policyResult) =>
  isPolicyResultPending(policyResult) || isPolicyResultConfirmed(policyResult)
